module.exports = __webpack_public_path__ + "static/assets/3ef0cd49bed0b258662a012cde4725d6.gif";